import React from 'react';
import EnhancedTableBase from '../components/common/EnhancedTable/EnhancedTableBase';
import { EnhancedTableProps } from '../components/common/EnhancedTable/types';
import './TestPage.css';

/**
 * TestPageTable component
 * 
 * This component extends the EnhancedTableBase component with specific styling and behavior
 * for the Test Page, following the same pattern as other enhanced tables in the app.
 */
function TestPageTable<T extends Record<string, any>>(props: EnhancedTableProps<T>) {
  return (
    <EnhancedTableBase
      {...props}
      className={`${props.className || ''}`}
      defaultSort={props.defaultSort}
      onSort={props.onSort}
    />
  );
}

export default TestPageTable;
